import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root'
})
export class MasterGuard implements CanActivate {

  constructor(private readonly router: Router) {}

  private readonly keycloak = inject(Keycloak);

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const authenticated = await this.keycloak.authenticated;

    if (!authenticated) {
      await this.keycloak.login({
        redirectUri: window.location.origin + state.url
      });
      return false;
    }

    const tokenDecoded = await this.decodeToken();
    if (!tokenDecoded) {
      await this.keycloak.login({ redirectUri: window.location.origin + state.url });
      return false;
    }

    let clientId = tokenDecoded.aud;

    if (Array.isArray(clientId)) {
      // pega o primeiro client que não seja "app-home"
      clientId = clientId.find((aud: string) => aud !== "app-home" && aud !== "account") ?? "";
    }

    const roles: string[] = tokenDecoded.resource_access?.[clientId]?.roles || [];


    if (!roles.includes('master')) {
      this.router.navigate(['/acesso-negado']);
      return false;
    }

    return true;
  }

  private async decodeToken(): Promise<any> {
    const tokenJwt = await this.keycloak.token;
    if (tokenJwt) {
      return this.parseJwt(tokenJwt);
    }
    return null;
  }

  private parseJwt(token: string): any {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload);
  }
}
